import DefaultMenu from './components/DefaultMenu';
import DefaultMenuSection, {
    BoxedMenuSection,
    SecondaryMenuSection,
    SecondaryMenuSectionWithDividers
} from './components/DefaultMenuSection';

const Menu = Object.assign(DefaultMenu, {
    Section: DefaultMenuSection,
    SecondarySection: SecondaryMenuSection,
    SecondarySectionWithDividers: SecondaryMenuSectionWithDividers,
    BoxedSection: BoxedMenuSection
});

export default Menu;
